import React from 'react';
import Spinner from './Spinner';

const SpinnerOverlay: React.FC = () => {
    return (
        <div id="spinner-overlay">
            <Spinner/>
        </div>
    )
}
export default SpinnerOverlay